import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import { ROUTES, WA_MESSAGES, openWhatsApp } from '../../../config/site';

const TESTIMONIALS = [
  {
    id: 1,
    name: 'Nisha Kumari',
    location: 'Mumbai, Maharashtra',
    avatar: '/assets/images/gen/avatar-nk.svg',
    videoUrl: '/videos/testimonial1.mp4',
    videoThumbnail: '/videos/thumbnails/testimonial1.jpg',
    winAmount: '₹2,50,000',
    game: 'Teen Patti Gold',
    quote:
      "Eight months on Nitin Online Book and the routine never changes: I message the desk, they answer in a minute, and the money is in my account before I finish making chai. Last month's ₹2.5 lakh landed in four minutes.",
    rating: 5,
    verified: true,
    playTime: '2:34',
  },
  {
    id: 2,
    name: 'Priya Sharma',
    location: 'Delhi, NCR',
    avatar: '/assets/images/gen/avatar-ps.svg',
    videoUrl: '/videos/testimonial2.mp4',
    videoThumbnail: '/videos/thumbnails/testimonial2.jpg',
    winAmount: '₹1,75,000',
    game: 'Andar Bahar Royal',
    quote:
      'I work full time, so I needed a platform I could trust without babysitting it. The Nitin online book sign up took two minutes on WhatsApp, and the guidance I get on bankroll limits is the reason I am still ahead.',
    rating: 5,
    verified: true,
    playTime: '3:12',
  },
  {
    id: 3,
    name: 'Amit Patel',
    location: 'Ahmedabad, Gujarat',
    avatar: '/assets/images/gen/avatar-ap.svg',
    videoUrl: '/videos/testimonial3.mp4',
    videoThumbnail: '/videos/thumbnails/testimonial3.jpg',
    winAmount: '₹4,20,000',
    game: 'Lightning Roulette',
    quote:
      'I started at ₹500 a session. The team taught me to track the wheel statistics instead of chasing losses, and three months later I had crossed ₹4.2 lakh. No inflated promises — just straight advice.',
    rating: 5,
    verified: true,
    playTime: '2:56',
  },
  {
    id: 4,
    name: 'Sneha Reddy',
    location: 'Hyderabad, Telangana',
    avatar: '/assets/images/gen/avatar-sr.svg',
    videoUrl: '/videos/testimonial4.mp4',
    videoThumbnail: '/videos/thumbnails/testimonial4.jpg',
    winAmount: '₹3,10,000',
    game: 'Dragon Tiger',
    quote:
      'What sold me was the app. The Nitin online book app download link came instantly, installed cleanly, and I have never had a session drop mid-hand. Withdrawals are the fastest I have used in India.',
    rating: 5,
    verified: true,
    playTime: '2:18',
  },
];

const VideoTestimonials = () => {
  const [active, setActive] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    if (isPlaying) return undefined;
    const interval = setInterval(() => setActive((i) => (i + 1) % TESTIMONIALS.length), 9000);
    return () => clearInterval(interval);
  }, [isPlaying]);

  const current = TESTIMONIALS[active];

  return (
    <section className="relative overflow-hidden py-24">
      <span className="aurora left-[-8%] bottom-[8%] h-[24rem] w-[24rem] bg-wa-green/20" aria-hidden="true" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <span className="badge-pill"><Icon name="Play" size={13} /> Success stories</span>
          <h2 className="mt-6 font-heading text-display font-bold text-white">
            Real players. Real <span className="gold-text">payouts</span>.
          </h2>
          <p className="mt-4 text-body-lg text-white/60">
            Filmed on their own phones, verified against real transaction IDs. No actors, no scripts — just players
            explaining how the WhatsApp desk changed the way they play.
          </p>
        </div>

        <div className="perspective mt-14 grid gap-8 lg:grid-cols-[1.35fr_1fr]">
          {/* Player */}
          <div className="card-flat overflow-hidden">
            <div className="relative aspect-video bg-black">
              {isPlaying ? (
                <video
                  ref={videoRef}
                  src={current.videoUrl}
                  className="h-full w-full bg-black object-contain"
                  controls
                  autoPlay
                  onEnded={() => setIsPlaying(false)}
                />
              ) : (
                <>
                  <Image
                    src={current.videoThumbnail}
                    alt={`${current.name} shares their Nitin Online Book win`}
                    className="h-full w-full bg-black object-contain"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-black/40" />
                  <button
                    onClick={() => setIsPlaying(true)}
                    aria-label={`Play ${current.name}'s testimonial`}
                    className="absolute inset-0 m-auto flex h-20 w-20 items-center justify-center rounded-full transition-transform duration-300 hover:scale-110"
                    style={{
                      background: 'radial-gradient(circle at 34% 28%, #FFF6D0, #F0C24B 52%, #7A5406)',
                      boxShadow: '0 1px 0 rgba(255,255,255,0.7) inset, 0 24px 44px -18px rgba(0,0,0,0.95), 0 0 44px -6px rgba(240,194,75,0.7)',
                    }}
                  >
                    <Icon name="Play" size={30} color="#150F02" />
                  </button>
                </>
              )}

              <span className="absolute bottom-4 right-4 rounded-full border border-white/15 bg-black/70 px-3 py-1 text-xs text-white backdrop-blur">
                {current.playTime}
              </span>
              {current.verified && (
                <span className="absolute right-4 top-4 flex items-center gap-1.5 rounded-full bg-wa-green px-3 py-1 text-xs font-semibold text-[#04220F]">
                  <Icon name="BadgeCheck" size={14} color="#04220F" /> Verified payout
                </span>
              )}
            </div>

            <div className="p-6 sm:p-7">
              <div className="flex flex-wrap items-center gap-4">
                <div className="relative">
                  <Image src={current.avatar} alt={current.name} className="h-14 w-14 rounded-full" />
                  <span className="absolute -bottom-1 -right-1 flex h-6 w-6 items-center justify-center rounded-full border-2 border-[#0B0B14] bg-wa-green">
                    <Icon name="Check" size={12} color="#04220F" />
                  </span>
                </div>

                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="font-heading text-xl font-bold text-white">{current.name}</h3>
                    <span className="flex">
                      {Array.from({ length: current.rating }).map((_, i) => (
                        <Icon key={i} name="Star" size={14} color="#F0C24B" fill="#F0C24B" />
                      ))}
                    </span>
                  </div>
                  <div className="mt-1 flex flex-wrap items-center gap-4 text-xs text-white/50">
                    <span className="inline-flex items-center gap-1"><Icon name="MapPin" size={12} /> {current.location}</span>
                    <span className="inline-flex items-center gap-1"><Icon name="Gamepad2" size={12} /> {current.game}</span>
                  </div>
                </div>

                <div className="rounded-2xl border border-wa-green/30 bg-wa-green/10 px-4 py-2 text-right">
                  <p className="text-[0.62rem] uppercase tracking-[0.16em] text-white/45">Withdrawn</p>
                  <p className="font-display text-lg font-bold text-wa-green">{current.winAmount}</p>
                </div>
              </div>

              <blockquote className="mt-6 border-l-2 border-royal-gold/60 pl-5 text-body text-white/70">
                “{current.quote}”
              </blockquote>
            </div>
          </div>

          {/* Selector */}
          <div className="space-y-4">
            {TESTIMONIALS.map((t, i) => (
              <button
                key={t.id}
                onClick={() => {
                  setActive(i);
                  setIsPlaying(false);
                }}
                className={`flex w-full items-center gap-4 rounded-2xl border p-4 text-left transition-all duration-400 ease-royal ${
                  i === active
                    ? 'border-royal-gold/60 bg-royal-gold/10 shadow-glow -translate-y-0.5'
                    : 'border-white/8 bg-white/[0.04] hover:-translate-y-0.5 hover:border-white/20'
                }`}
              >
                <span className="relative shrink-0">
                  <Image src={t.avatar} alt={t.name} className="h-12 w-12 rounded-full" />
                  {i === active && (
                    <span className="absolute inset-0 animate-ping rounded-full border-2 border-royal-gold/60" />
                  )}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block truncate font-display text-sm font-semibold text-white">{t.name}</span>
                  <span className="block truncate text-xs text-white/45">{t.game} · {t.location.split(',')[0]}</span>
                </span>
                <span className="text-right">
                  <span className="block font-display text-sm font-bold text-wa-green">{t.winAmount}</span>
                  <span className="text-[0.62rem] text-white/35">{t.playTime}</span>
                </span>
              </button>
            ))}

            <div className="panel-gold p-6 text-center">
              <h3 className="font-heading text-xl font-bold text-white">Want the same playbook?</h3>
              <p className="mt-2 text-sm text-white/60">
                Ask the desk for the free strategy pack — bankroll rules, table selection and the exact limits our
                winners use.
              </p>
              <button
                onClick={() => openWhatsApp(WA_MESSAGES.strategy)}
                className="btn-3d btn-3d-wa mt-5 w-full !py-3 text-sm"
              >
                <FaWhatsapp size={17} /> Get winning strategies
              </button>
              <Link
                to={ROUTES.winners}
                className="mt-3 inline-flex items-center justify-center gap-1.5 text-xs text-white/50 transition hover:text-royal-gold"
              >
                See all success stories <Icon name="ArrowRight" size={13} />
              </Link>
            </div>
          </div>
        </div>

        {/* Footer stats */}
        <div className="mt-12 grid grid-cols-3 gap-4">
          {[
            { v: '₹12Cr+', l: 'Total winnings paid' },
            { v: '2,847', l: 'Verified success stories' },
            { v: '4.9★', l: 'Average rating' },
          ].map((s) => (
            <div key={s.l} className="stat-3d">
              <div className="font-display text-2xl font-bold gold-text">{s.v}</div>
              <div className="mt-1 text-xs uppercase tracking-[0.14em] text-white/45">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoTestimonials;
